import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './LegalPage.css';


const RefundPolicy = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <Link to="/" className="back-link">← Back to Home</Link>
          
          <h1 className="legal-title">Refund Policy</h1>
          <p className="legal-date">Last Updated: January 27, 2026</p>
          
          <div className="legal-content">
            <p className="legal-intro">
              At VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED (operating as WhiteLabelDevs), we maintain transparent and fair billing.
            </p>
            
            <section className="legal-section">
              <h2>1. Eligibility</h2>
              <p>Refund requests must be submitted in writing to <a href="mailto:support@whitelabeldevs.com">support@whitelabeldevs.com</a></p>
            </section>
            
            <section className="legal-section">
              <h2>2. Refund Conditions</h2>
              <p>If cancellation occurs after project approval:</p>
              <ul>
                <li>10% administrative fee is non-refundable</li>
                <li>Work done will be calculated on a prorata basis from the estimated hours</li>
                <li>If cancellation is requested after 2 days from approval, completed effort will be deducted before refund</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. Formula Example</h2>
              <p className="formula">Refund = Amount Paid – 10% fee – (Completed hours × hourly rate)</p>
            </section>
            
            <section className="legal-section">
              <h2>4. Non-Refundable</h2>
              <ul>
                <li>Completed milestones</li>
                <li>Delivered files or deployed systems</li>
                <li>Third-party tools, licenses, or server costs</li>
                <li>Hosting services already consumed</li>
                <li>Domain registration and SSL certificate fees</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Hosting Service Refunds</h2>
              <p>Cloud hosting services are billed monthly or annually in advance:</p>
              <ul>
                <li>Monthly plans: No refunds for partial months</li>
                <li>Annual plans: Pro-rated refund for unused full months (minus 10% admin fee)</li>
                <li>Setup fees are non-refundable</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>6. Processing Time</h2>
              <p>Approved refunds are processed within 7–10 business days.</p>
            </section>
          </div>
          
          <div className="legal-footer">
            <p><strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong></p>
            <p>Operating as: WhiteLabelDevs</p>
            <p>CIN: U62090UP2026PTC241378</p>
            <p>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RefundPolicy;